import React from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register( CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels );

export default function ProductUsageChart({ productUsageData }) {

    if ( !Array.isArray(productUsageData) || productUsageData.length === 0 ) {
      return (
        <div className="App h-w-100 white-color">
          <p className="text-black ms-4"> No data available! </p>
        </div>
      );
    }

    // ============================================
    // GET LATEST MONTH
    // ============================================
    const sortedData = [...productUsageData].sort(
        (a, b) =>
            new Date(b.year, b.month - 1) -
            new Date(a.year, a.month - 1)
    );
    const latestMonth = sortedData[0]?.month;
    const latestYear = sortedData[0]?.year;

    // ============================================
    // FILTER LATEST MONTH
    // ============================================
    const currentMonthData = productUsageData.filter(
        (item) =>
            item.month === latestMonth &&
            item.year === latestYear
    );

    const monthNames = [ "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec" ];

    const data = {
        labels: currentMonthData.map(
            (item) => item.product_name
        ),
        datasets: [
          {
              label: "Product Usage",
              data: currentMonthData.map(
                  (item) => Number(item.usage_percentage) || 0
              ),
              backgroundColor: "#f06b22",
              borderColor: "#f06b22",
              borderWidth: 1,
              borderRadius: 6,
              borderSkipped: false,
              barPercentage: 0.85,
              categoryPercentage: 0.95,
              datalabels: {
                  // color: "#ffffff",
                  color: (context) => {
                    const value = context.dataset.data[context.dataIndex];
                    return value === 0 ? "#313932" : "#fff";
                  },
                  font: {
                      size: window.innerWidth < 767 ? 10 : 13,
                      family: "Graphik-Semibold, sans-serif",
                  },
                  formatter: (value) => `${value}%`,
                  // anchor: "center",
                  // align: "center",
              },
          },
      ],
    };

    const options = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                beginAtZero: true,
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                    color: "#ffffff",
                    font: {
                        family:"Graphik-Light, sans-serif",
                        size: window.innerWidth > 767 ? 8 : 10,
                    },
                },
                border: {
                    display: false,
                },
            },
            y: {
              grid: {
                  display: false,
              },
              ticks: {
                  font: () => ({
                      size: window.innerWidth < 1100 ? 10 : 15,
                      family: "Graphik-Light, sans-serif",
                      weight: "500",
                      color: "rgb(49, 57, 50)",
                  }),
                  align: "center",
                  padding: 10,
                  crossAlign: "far",
              },
              border: {
                  display: false,
              },
              categoryPercentage: 1,
              barPercentage: 0.8,
          },
        },
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                font: (context) => {
                    return {
                        size: window.innerWidth < 1100 ? 10 : 15,
                        family: "Graphik-Light, sans-serif",
                    };
                },
                color: "#ffffff",
                formatter: (value) => `${value}%`,
                // align: (context) => {
                //     const value = context.dataset.data[ context.dataIndex ];
                //     return value <= 1 ? "end" : "center";
                // },
                // anchor: (context) => {
                //     const value = context.dataset.data[ context.dataIndex ];
                //     return value <= 1 ? "end" : "center";
                // },
                anchor: "end",
                align: "left",
                clamp: true,
            },
            tooltip: {
                callbacks: {
                    title: function (tooltipItem) {
                        return tooltipItem[0].label;
                    },
                    label: function (tooltipItem) {
                        const value = tooltipItem.raw;
                        const dataIndex = tooltipItem.dataIndex;
                        const respondentCount = currentMonthData[ dataIndex ]?.respondent_count ?? "N/A";
                        return ` Usage: ${value}% | Count: ${respondentCount}`;
                    },
                },
                titleFont: {
                    family: "Graphik-Light, sans-serif",
                    size: 12,
                },
                bodyFont: {
                    family: "Graphik-Light, sans-serif",
                    size: 10,
                },
                footerFont: {
                    family: "Graphik-Light, sans-serif",
                    size: 10,
                },
            },
        },
        layout: {
            padding: {
                top: 0,
                right: 20,
                bottom: 20,
                left: 12,
            },
        },
    };
    
    return (
        <div className="container-fluid">
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="mb-3"> Product Usage 
                        {/* -{" "} {monthNames[latestMonth - 1]}{" "} {latestYear} */}
                    </h5>
                    <div className="App metricChart h-w-100" style={{ height: `${Math.max(300, currentMonthData.length * 42)}px` }} >
                        <Bar data={data} options={options} />
                    </div>
                </div>
            </div>
        </div>
    );
}



















// import React from "react";
// import { Chart as ChartJS,CategoryScale,LinearScale,BarElement,PointElement,LineElement,Tooltip,Legend } from "chart.js";
// import { Bar, Line } from "react-chartjs-2";
// ChartJS.register( CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend );

// // ======================================================
// // SAMPLE DATA
// // Replace this later with your API response
// // ======================================================
// const productUsageData = [
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 16,
//     product_name: "A2 testing",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 4,
//     product_name: "Artificial Breeding (AB)",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 7,
//     product_name: "Beef semen",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 14,
//     product_name: "BVD Testing",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 11,
//     product_name: "GeneMark Genomics",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 19,
//     product_name: "Heat detection solutions",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 3,
//     product_name: "Herd Testing",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 13,
//     product_name: "Johne’s Testing",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 9,
//     product_name: "KiwiPrime",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 17,
//     product_name: "Mastitis Multiplex",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 15,
//     product_name: "Milk Pregnancy testing",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 1,
//     product_name: "MINDA",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 2,
//     product_name: "MyLIC",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 20,
//     product_name: "None of these",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 18,
//     product_name: "On-farm weighing services",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 21,
//     product_name: "Other LIC product or service",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 10,
//     product_name: "Premier Sires",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 5,
//     product_name: "Sexed semen",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 6,
//     product_name: "SGL semen",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 8,
//     product_name: "Synergizer",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 12,
//     product_name: "Tags",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
//   {
//     brandId: 6,
//     brand_name: "LIC",
//     productId: 23,
//     product_name: "verbatim",
//     month: 9,
//     year: 2026,
//     respondent_count: 44,
//     total_respondents: 44,
//     usage_percentage: "100.00",
//   },
// ];
// // ======================================================
// // MONTH NAMES
// // ======================================================
// const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
// // ======================================================
// // GET LATEST MONTH
// // ======================================================

// const sortedData = [...productUsageData].sort(
//   (a, b) =>
//     new Date(b.year, b.month - 1) -
//     new Date(a.year, a.month - 1)
// );

// const latestMonth = sortedData[0]?.month;
// const latestYear = sortedData[0]?.year;
// // ======================================================
// // BAR CHART DATA
// // ======================================================
// const currentMonthData = productUsageData.filter(
//   (item) =>
//     item.month === latestMonth &&
//     item.year === latestYear
// );

// const barData = {
//   labels: currentMonthData.map(
//     (item) => item.product_name
//   ),

//   datasets: [
//     {
//       label: "Product Usage",

//       data: currentMonthData.map(
//         (item) => Number(item.usage_percentage)
//       ),

//       borderWidth: 1,
//       borderRadius: 4,

//       barPercentage: 0.7,
//       categoryPercentage: 0.8,
//     },
//   ],
// };

// // ======================================================
// // BAR CHART OPTIONS
// // ======================================================
// const barOptions = {
//   responsive: true,
//   maintainAspectRatio: false,

//   plugins: {
//     legend: {
//       display: false,
//     },

//     tooltip: {
//       backgroundColor: "rgba(255, 255, 255, 0.95)",
//       titleColor: "#333",
//       bodyColor: "#333",
//       borderColor: "#ddd",
//       borderWidth: 1,

//       callbacks: {
//         label: (context) => {
//           return ` Usage: ${context.raw}%`;
//         },
//       },
//     },
//   },

//   scales: {
//     x: {
//       grid: {
//         display: false,
//       },

//       ticks: {
//         autoSkip: false,
//         maxRotation: 60,
//         minRotation: 45,
//       },
//     },

//     y: {
//       beginAtZero: true,
//       max: 100,

//       ticks: {
//         callback: (value) => `${value}%`,
//       },
//     },
//   },
// };
// // ======================================================
// // GET UNIQUE MONTHS
// // ======================================================
// const uniqueMonths = [
//   ...new Map(
//     productUsageData.map((item) => [
//       `${item.year}-${item.month}`,
//       {
//         month: item.month,
//         year: item.year,
//       },
//     ])
//   ).values(),
// ].sort(
//   (a, b) =>
//     new Date(a.year, a.month - 1) -
//     new Date(b.year, b.month - 1)
// );
// // ======================================================
// // LINE CHART LABELS
// // ======================================================
// const lineLabels = uniqueMonths.map(
//   (item) =>
//     `${monthNames[item.month - 1]} ${item.year}`
// );
// // ======================================================
// // GET UNIQUE PRODUCTS
// // ======================================================
// const products = [
//   ...new Map(
//     productUsageData.map((item) => [
//       item.productId,
//       item.product_name,
//     ])
//   ).entries(),
// ];
// // ======================================================
// // LINE COLORS
// // ======================================================
// const lineColors = [
//   "#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab","#2f4b7c",
//   "#665191","#a05195","#d45087","#f95d6a","#ff7c43","#ffa600","#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd",
//   "#8c564b"
// ];
// // ======================================================
// // LINE CHART DATASETS
// // ======================================================
// const lineDatasets = products.map(
//   ([productId, productName], index) => {
//     const data = uniqueMonths.map(
//       (monthItem) => {
//         const record = productUsageData.find(
//           (item) =>
//             item.productId === productId &&
//             item.month === monthItem.month &&
//             item.year === monthItem.year
//         );
//         return record ? Number(record.usage_percentage) : null;
//       }
//     );

//     return {
//       label: productName,
//       data: data,
//       borderColor: lineColors[index % lineColors.length],
//       backgroundColor: lineColors[index % lineColors.length],
//       borderWidth: 2,
//       tension: 0.3,
//       pointRadius: 3,
//       pointHoverRadius: 5,
//       spanGaps: true,
//     };
//   }
// );
// // ======================================================
// // LINE CHART DATA
// // ======================================================
// const lineData = {
//   labels: lineLabels,
//   datasets: lineDatasets,
// };
// // ======================================================
// // LINE CHART OPTIONS
// // ======================================================
// const lineOptions = {
//   responsive: true,
//   maintainAspectRatio: false,

//   interaction: {
//     mode: "index",
//     intersect: false,
//   },

//   plugins: {
//     legend: {
//       position: "bottom",

//       labels: {
//         usePointStyle: true,
//         pointStyle: "circle",
//         padding: 15,
//       },
//     },

//     tooltip: {
//       backgroundColor: "rgba(255, 255, 255, 0.95)",
//       titleColor: "#333",
//       bodyColor: "#333",
//       borderColor: "#ddd",
//       borderWidth: 1,

//       callbacks: {
//         label: (context) => {
//           return `${context.dataset.label}: ${context.raw}%`;
//         },
//       },
//     },

//   },

//   scales: {
//     x: {
//       grid: {
//         display: false,
//       },
//     },
//     y: {
//       beginAtZero: true,
//       max: 100,
//       ticks: {
//         callback: (value) => `${value}%`,
//       },
//     },

//   },

// };
// // ======================================================
// // COMPONENT
// // ======================================================
// const ProductUsageCharts = () => {
//   if ( !productUsageData || productUsageData.length === 0 ) {
//     return (
//       <div className="text-center p-4">
//         No product usage data available.
//       </div>
//     );
//   }
//   return (
//     <div className="container-fluid">
//       <div className="card mb-4">
//         <div className="card-body">
//           <h5 className="mb-3"> Product Usage 
//              -{" "} {monthNames[latestMonth - 1]} {latestYear}  
//             </h5>
//           <div style={{ width: "100%", height: "400px", }} >
//             <Bar data={barData} options={barOptions} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductUsageCharts;